import { Injectable } from "@angular/core";
import { catchError, map, Observable, of } from "rxjs";
import { HttpService } from "src/app/modules/core/core/services/http.service";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class VersionService {
  constructor(private http: HttpService) {}

  getVersion(): Observable<string> {
    if (!environment.production) {
      return of(`Desarrollo - ${new Date().toLocaleString()}`);
    }

    return this.http
      .get<{ version: string }>("/version.json", {
        skipErrorHandling: true,
      })
      .pipe(
        map((res) => `v${res.version}`),
        catchError(() => [""]),
      );
  }
}
